var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDocumentFolder = function SvgDocumentFolder(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 30.694",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#414a5f",
    d: "M36.47 4.027H20.237L16.991.176A.49.49 0 0 0 16.6 0H3.53A3.567 3.567 0 0 0 0 3.571v23.554a3.567 3.567 0 0 0 3.53 3.569h32.94A3.567 3.567 0 0 0 40 27.125V7.6a3.567 3.567 0 0 0-3.53-3.569Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDocumentFolder);
export default ForwardRef;